<template>
  <div>
    <top-bar title="Excluir Conta"/>
    <div class="mx-auto mt-3" style="max-width: 400px">
      <loading v-show="load" text="Por favor aguarde.."/>
      <div class="container" v-show="!load">
        <div v-if="token">
          <h6 class="font-weight-bold">{{empresa.nome_fantasia}}</h6>
          <p>
            Sentimos muito que você queira nos deixar.
          </p>
        </div>
        <div v-else>
          <h6 class="font-weight-bold">Como excluir minha conta {{empresa.nome_fantasia}}?</h6>
          <p>
            Para excluir sua conta, faça o login, acesse o menu "Perfil", clique no link "Ajuda" e depois em "Excluir minha conta".
          </p>
        </div>
        <p>
          Uma vez que a conta for excluída, seus dados serão removidos do nosso servidor. É importante destacar:
        </p>
        <ul>
          <li>Os pontos do Programa de Fidelidade serão perdidos.</li>
          <li>Os cupons de desconto em seu nome não poderão ser recuperados.</li>
          <li>Você não terá mais acesso ao histórico da sua conta.</li>
          <li>Após a exclusão bem-sucedida da conta, manteremos os dados dos pedidos realizados apenas para fins de auditoria financeira.</li>
        </ul>
        <div class="text-center" style="margin-top: 34px">
          <a href="javascript:" class="btn btn-outline-primary text-decoration-none" @click="excluirConta" v-if="token">Excluir minha conta</a>
          <router-link :to="url + '/perfil'" class="btn btn-outline-primary text-decoration-none" v-else>Fazer Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../components/Loading";
  import TopBar from "../components/TopBar";

  export default {
    name: 'ExcluirConta',
    components: {TopBar, Loading},
    data() {
      return {
        token: localStorage.getItem('token'),
        load: false,
        url: ''
      }
    },

    methods: {
      voltar() {
        this.$router.go(-1)
      },

      excluirConta() {
        this.$swal({
          text: 'Por favor tenha em mente que a exclusão da conta é irreversível, deseja realmente excluir sua conta do sistema?',
          buttons: ["Cancelar", "Sim!"],
          dangerMode: true
        }).then((res) => {
          if (res) {
            this.load = true;
            const url = this.$helpers.base_url(this, this.empresa);

            this.$http.post(url + this.token + '/cliente/excluir-conta', { token: this.token })
              .then(res => {
                this.load = false;

                if (res.data && res.data.success) {
                  this.$swal('Sua conta e seus dados foram excluídos com sucesso!')
                  this.$store.commit('logout');
                  this.$router.push(this.url + '/');

                } else {
                  this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
                }

              }, res => {
                this.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
              });
          }
        });
      }
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      }
    }
  }
</script>

<style scoped>
</style>
